import { createCashedOutEntriesStore } from '@/hooks/create-cashed-out-entries-store';

import { Bet } from './types';

/** SBK's session record of entries cashed out in place from the bet-history list. */
export const useSbkCashedOutEntries = createCashedOutEntriesStore<Bet>();
